export default class ImgGallery {

    private _cont: HTMLElement;
    private _index: number = -1;
    private _items: NodeListOf<HTMLImageElement>;

    constructor(cont: HTMLElement) {
        this._cont = cont;
        this._items = this._cont.querySelectorAll<HTMLImageElement>(":scope>img");

        if (this._items.length > 1)
            this._show(0);
        else if (this._items.length == 1)
            this._items[0].classList.add("active");
    }

    private _show(index: number) {
        const prevIndex = this._index;
        this._index = index < 0 ? this._items.length - 1 : (index >= this._items.length ? 0 : index);

        if (prevIndex > -1)
            this._items[prevIndex].classList.remove("active");

        this._items[this._index].classList.add("active");
        setTimeout(() => this._show(this._index + 1), 3500);
    }
}